import Line from './Line';
import { isDefined, toPixel } from '../utils';

export default class VerticalLine extends Line {
  type = 'vertical';
  constructor(...props) {
    super(...props);
    const p = props[1].y || 0;
    this.position = p;
    this.lineData.set({ to: props[1].y });
  }

  onUpdate({ to, reset }) {
    this.resetLine(reset);

    if (this.direction === 1) {
      let yFrom = this.startPos.y;

      if(isDefined(this.maxLength)){
        if(Math.abs(yFrom - to) > this.maxLength){
          yFrom = to - this.maxLength
        }
      }

      this.line
        .moveTo(this.startPos.x, yFrom)
        .lineTo(this.startPos.x, to);
    } else {
      this.line
        .moveTo(this.startPos.x, this.lineData.endDraw.to)
        .lineTo(this.startPos.x, to);
    }
  }

  extend(startPosition, height, endPosition, duration, delay = 0) {
    const sp = toPixel(startPosition, height);
    const p = this.draw({ to: sp }, 0);
    this.lineData.to = sp;

    if (!isDefined(endPosition)) return p;

    return this.updateStartPosition({ y: endPosition }, duration, delay);
  }

  getNextPosition() {
    return { x: this.startPos.x, y: this.lineData.endDraw.to };
  }
}
